<template>
  <div class="cta-help">
    <h3 class="cta-help__h">{{ $t("faq.noResponseFound", lang) }}</h3>
    <div class="cta-help__actions" v-html="$t('faq.noResponseFoundCta', lang)">
      
    </div>
  </div>
</template>
<script>
export default {
  name: "CtaFaqHelp",
  props: {
    lang: {
      type: String,
      default: "en-GB",
    },
  },
};
</script>
